















































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { WebhooksModule } from '@/store/Settings/WebhooksModule';

@Component({ name: 'WebhookPublicKey' })
export default class extends SaascadaVueDialog {

    dialog = false;
    copied: boolean = false;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            WebhooksModule.getPublicKey();
            this.copied = false;
        }
    }

    get publicKey() {
        return WebhooksModule.publicKey;
    }

    copy() {
        try {
            navigator.clipboard.writeText(this.publicKey);
            this.copied = true;
        }
        catch (err) {
            this.copied = false;
        }
    }

}
